import { CheckinList } from "components/front/PMS/Checkin/List/CheckinList"
import React from "react"

export const CheckinListRoute = () => {


  return <div className="checkin-list-route">
    <CheckinList />
  </div>
}